"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractIMDbId = void 0;
var extractIMDbId = function (metaItem) {
    if (!metaItem || !Array.isArray(metaItem.links)) {
        return null;
    }
    var imdbLink = metaItem.links.find(function (link) {
        return link &&
            link.category === 'imdb' &&
            typeof link.url === 'string' &&
            link.url.includes('imdb.com');
    });
    if (!(imdbLink === null || imdbLink === void 0 ? void 0 : imdbLink.url)) {
        return null;
    }
    var match = imdbLink.url.match(/tt\d+/);
    return match ? match[0] : null;
};
exports.extractIMDbId = extractIMDbId;
